// extracted by mini-css-extract-plugin
export default {"assignments":"AssignmentFieldLayout_assignments__JD4jc","label":"AssignmentFieldLayout_label__IQj9V","assignment":"AssignmentFieldLayout_assignment__POfLi"};